import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Printer, ChevronLeft } from "lucide-react";
import api, { API } from "../lib/api";

export default function StampaQr() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const vehicleId = params.get("vehicle");
  const fromVehicle = params.get("from");
  const backVehicle = vehicleId || fromVehicle;
  const idsParam = params.get("ids");
  const idSet = idsParam ? idsParam.split(",").filter(Boolean) : null;
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    api.get("/vehicles").then(({ data }) => setVehicles(data)).catch(() => {});
  }, []);

  const shown = vehicleId
    ? vehicles.filter((v) => v.id === vehicleId)
    : idSet
      ? idSet.map((id) => vehicles.find((v) => v.id === id)).filter(Boolean)
      : vehicles;

  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100 print:bg-white print:text-black p-6">
      <div className="no-print flex items-center justify-between mb-6 max-w-5xl mx-auto">
        <button onClick={() => navigate(backVehicle ? `/admin/mezzi/${backVehicle}` : "/admin/mezzi")} className="flex items-center gap-1 text-slate-400 hover:text-slate-200 text-sm">
          <ChevronLeft className="w-4 h-4" /> {backVehicle ? "Torna al mezzo" : "Torna ai mezzi"}
        </button>
        <button onClick={() => window.print()} data-testid="do-print-btn" className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 px-4 py-2.5 rounded-xl font-semibold text-sm">
          <Printer className="w-4 h-4" /> Stampa / Salva PDF
        </button>
      </div>
      <h1 className="font-head text-2xl font-bold mb-6 max-w-5xl mx-auto no-print">{vehicleId && shown.length ? `QR Code · ${shown[0].targa}` : idSet ? `QR Code · ${shown.length} mezzi filtrati` : "QR Code mezzi · da attaccare su ogni veicolo"}</h1>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
        {shown.map((v) => (
          <div key={v.id} className="bg-white text-black rounded-xl border border-slate-300 p-4 flex flex-col items-center break-inside-avoid" data-testid={`qr-card-${v.targa}`}>
            <div className="text-[11px] font-bold tracking-wide text-slate-600">MEZZO {v.n_soc}</div>
            <div className="font-plate font-bold text-xl mb-2">{v.targa}</div>
            <img src={`${API}/vehicles/${v.id}/qr`} alt={`QR ${v.targa}`} className="w-36 h-36" />
            <div className="text-[11px] text-slate-600 mt-2 text-center leading-tight">📱 Scansiona per<br />segnalare un problema</div>
          </div>
        ))}
      </div>
    </div>
  );
}
